import { render, staticRenderFns } from "./AffiliateOverview.vue?vue&type=template&id=61fa90a2&scoped=true&"
import script from "./AffiliateOverview.vue?vue&type=script&lang=js&"
export * from "./AffiliateOverview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61fa90a2",
  null
  
)

export default component.exports